import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { Lead, CreateLeadDto } from '@/types/lead';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function normalizeCreateLeadDto(dto: CreateLeadDto): CreateLeadDto {
  const assignedTo = dto.assignedTo?.trim();
  if (assignedTo && UUID_RE.test(assignedTo)) {
    return { ...dto, assignedTo };
  }

  const { assignedTo: _assignedTo, ...rest } = dto;
  return rest;
}

export function useCreateLead() {
  const queryClient = useQueryClient();

  return useApiMutation<Lead, CreateLeadDto>({
    mutationFn: (dto) =>
      apiPost<Lead, CreateLeadDto>(
        operationsClient,
        leadEndpoints.create(),
        normalizeCreateLeadDto(dto),
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead created');
    },
  });
}
